(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/numbergames-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/numbergames-slice.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _RTK = RTK,
  createSlice = _RTK.createSlice,
  createSelector = _RTK.createSelector;
const _svs$gamePackage$mapp = svs.gamePackage.mappers,
  generateGames = _svs$gamePackage$mapp.generateGames,
  gamesSortOrder = _svs$gamePackage$mapp.gamesSortOrder,
  getJackpots = _svs$gamePackage$mapp.getJackpots,
  getPackageDraws = _svs$gamePackage$mapp.getPackageDraws;
const gameWager = svs.numbergames.gameWager;
const packageConfig = svs.gamePackage.data.packageConfig;
const packageSizes = packageConfig.packageSizes,
  _packageConfig$defaul = packageConfig.defaultSelectedIndex,
  defaultSelectedIndex = _packageConfig$defaul === void 0 ? 1 : _packageConfig$defaul;
const gamePackageSlice = svs.gamePackage.redux.gamePackageSlice;
const numbergamesSlice = createSlice({
  name: 'numbergames',
  initialState() {
    const activeIndex = defaultSelectedIndex;
    const draws = getPackageDraws();
    const games = generateGames({
      packageSizes,
      activeIndex
    });
    return {
      draws,
      jackpots: getJackpots({
        games
      }),
      games,
      gamesDisplayOrder: gamesSortOrder({
        games,
        draws
      })
    };
  },
  reducers: {
    huxflux: (state, action) => {
      const game = state.games.find(g => g.uniqueId === action.payload.uniqueId);
      game.isHuxfluxed = true;
      game.boards = game.boards.map(board => _objectSpread(_objectSpread({}, board), gameWager.randomizeRow(board)));
      if (game.hasJoker) {
        game.joker = _objectSpread(_objectSpread({}, game.joker), gameWager.randomizeRow(game.joker));
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(gamePackageSlice.actions.updateIndex, (state, action) => {
      const activeIndex = parseInt(action.payload.activeIndex, 10);
      const games = action.payload.persistedGames || generateGames({
        packageSizes,
        activeIndex
      });
      state.games = games;
      state.gamesDisplayOrder = gamesSortOrder({
        games,
        draws: state.draws
      });
    }).addCase(gamePackageSlice.actions.updateDraws, (state, action) => {
      const draws = action.payload;
      state.draws = draws;
      state.jackpots = getJackpots({
        games: state.games
      });
      state.gamesDisplayOrder = gamesSortOrder({
        games: state.games,
        draws
      });
    });
  }
});
svs.gamePackage.redux.selectors.selectDraw = createSelector(state => state.numbergames.draws, (_, productItsId) => productItsId, (draws, productItsId) => draws.find(draw => draw.productItsId === productItsId));
svs.gamePackage.redux.selectors.selectJackpot = createSelector(state => state.numbergames.jackpots, (_, productItsId) => productItsId, (jackpots, productItsId) => jackpots.find(j => j.productItsId === productItsId));
svs.gamePackage.redux.selectors.selectGame = createSelector(state => state.numbergames.games, (_, uniqueId) => uniqueId, (games, uniqueId) => games.find(game => game.uniqueId === uniqueId));
svs.gamePackage.redux.numbergamesSlice = numbergamesSlice;

 })(window);